var React = require('react');

function IcAwsOpsworksLayers (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M39.145,0H0.855c-0.47,0-0.851,0.381-0.851,0.851v14.363c0,0.47,0.381,0.851,0.851,0.851h38.29\n\tc0.47,0,0.851-0.381,0.851-0.851V0.851C39.996,0.381,39.615,0,39.145,0z M38.294,14.363H1.706V1.702h36.588\n\tC38.294,1.702,38.294,14.363,38.294,14.363z M39.145,23.935H0.855c-0.47,0-0.851,0.381-0.851,0.851v14.363\n\tc0,0.47,0.381,0.851,0.851,0.851h38.29c0.47,0,0.851-0.381,0.851-0.851V24.786C39.996,24.316,39.615,23.935,39.145,23.935z\n\t M38.294,38.298H1.706V25.637h36.588C38.294,25.637,38.294,38.298,38.294,38.298z"}));
}

IcAwsOpsworksLayers.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsOpsworksLayers;

IcAwsOpsworksLayers.default = IcAwsOpsworksLayers;
